import React from "react";
import { Link } from 'react-router-dom';
import { Box, Card, CardMedia, CardContent, Typography } from "@mui/material";
import './Item.css';

const Item = ({ detalle }) => {
  const finalPrice = detalle?.co_price === 0
    ? detalle?.price
    : detalle?.price - (detalle?.price * (detalle?.co_price / 100));

  return (
    <Link to={{ pathname: `/DetalleProducto/${detalle?.id}`, state: { IdDoc: detalle?.id } }} style={{ textDecoration: 'none' }} className="item-card">
      <Card >
        {/* Imagen del producto */}
        <CardMedia
          component="img"
          image={detalle?.Img["1"]?.UrlMin}
          alt={detalle?.nombre}
          className="item-image"
          loading="lazy"
        />

        <CardContent sx={{ textAlign: 'center' }}>
          {/* Nombre del producto */}
          <Typography variant="body1" className="item-name" component="span">
            {detalle?.nombre}
          </Typography>

          {/* Precio con o sin descuento */}
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography variant="body1" className="item-price" component="span">
              $ {finalPrice}
            </Typography>
            {detalle?.co_price > 0 && (
              <Typography variant="body2" className="item-compare-price" component="span">
                $ {detalle?.price}
              </Typography>
            )}
          </Box>

          {/* Descuento si existe */}
          {detalle?.co_price > 0 && (
            <Typography variant="caption" className="moredetallDes" component="span">
              {detalle?.co_price}%
            </Typography>
          )}

          {/* Icono de "más información" */}
          <Box className="moreinfo">
            <img src={process.env.PUBLIC_URL + "/img/more.png"} alt="Más detalles" className="moredetall" />
          </Box>
        </CardContent>
      </Card>
    </Link>
  );
};

export default Item;
